import { flatKeywordList } from '../../utils.js';

export const keywords = flatKeywordList({
  // https://docs.oracle.com/cd/B19306_01/appdev.102/b14261/reservewords.htm
  all: [
    // 'A',
    'ADD',
    'AGENT',
    'AGGREGATE',
    'ALL',
    'ALTER',
    'AND',
    'ANY',
    'ARRAY',
    'ARROW',
    'AS',
    'ASC',
    'AT',
    'ATTRIBUTE',
    'AUTHID',
    'AVG',
    'BEGIN',
    'BETWEEN',
    'BFILE_BASE',
    'BINARY',
    'BLOB_BASE',
    'BLOCK',
    'BODY',
    'BOTH',
    'BOUND',
    'BULK',
    'BY',
    'BYTE',
    // 'C',
    'CALL',
    'CALLING',
    'CASCADE',
    'CASE',
    'CHAR',
    'CHAR_BASE',
    'CHARACTER',
    'CHARSET',
    'CHARSETFORM',
    'CHARSETID',
    'CHECK',
    'CLOB_BASE',
    'CLOSE',
    'CLUSTER',
    'CLUSTERS',
    'COLAUTH',
    'COLLECT',
    'COLUMNS',
    'COMMENT',
    'COMMIT',
    'COMMITTED',
    'COMPILED',
    'COMPRESS',
    'CONNECT',
    'CONSTANT',
    'CONSTRUCTOR',
    'CONTEXT',
    'CONVERT',
    'COUNT',
    'CRASH',
    'CREATE',
    'CURRENT',
    'CURSOR',
    'CUSTOMDATUM',
    'DANGLING',
    'DATA',
    'DATE',
    'DATE_BASE',
    'DAY',
    'DECIMAL',
    'DECLARE',
    'DEFAULT',
    'DEFINE',
    'DELETE',
    'DESC',
    'DETERMINISTIC',
    'DISTINCT',
    'DOUBLE',
    'DROP',
    'DURATION',
    'ELEMENT',
    'ELSE',
    'ELSIF',
    'EMPTY',
    'END',
    'ESCAPE',
    'EXCEPT',
    'EXCEPTION',
    'EXCEPTIONS',
    'EXCLUSIVE',
    'EXECUTE',
    'EXISTS',
    'EXIT',
    'EXTERNAL',
    'FETCH',
    'FINAL',
    'FIXED',
    'FLOAT',
    'FOR',
    'FORALL',
    'FORCE',
    'FORM',
    'FROM',
    'FUNCTION',
    'GENERAL',
    'GOTO',
    'GRANT',
    'GROUP',
    'HASH',
    'HAVING',
    'HEAP',
    'HIDDEN',
    'HOUR',
    'IDENTIFIED',
    'IF',
    'IMMEDIATE',
    'IN',
    'INCLUDING',
    'INDEX',
    'INDEXES',
    'INDICATOR',
    'INDICES',
    'INFINITE',
    'INSERT',
    'INSTANTIABLE',
    'INT',
    'INTERFACE',
    'INTERSECT',
    'INTERVAL',
    'INTO',
    'INVALIDATE',
    'IS',
    'ISOLATION',
    'JAVA',
    'LANGUAGE',
    'LARGE',
    'LEADING',
    'LENGTH',
    'LEVEL',
    'LIBRARY',
    'LIKE',
    'LIKE2',
    'LIKE4',
    'LIKEC',
    'LIMIT',
    'LIMITED',
    'LOCAL',
    'LOCK',
    'LONG',
    'LOOP',
    'MAP',
    'MAX',
    'MAXLEN',
    'MEMBER',
    'MERGE',
    'MIN',
    'MINUS',
    'MINUTE',
    'MOD',
    'MODE',
    'MODIFY',
    'MONTH',
    'MULTISET',
    'NAME',
    'NAN',
    'NATIONAL',
    'NATIVE',
    'NCHAR',
    'NEW',
    'NOCOMPRESS',
    'NOCOPY',
    'NOT',
    'NOWAIT',
    'NULL',
    'NUMBER_BASE',
    'OBJECT',
    'OCICOLL',
    'OCIDATE',
    'OCIDATETIME',
    'OCIDURATION',
    'OCIINTERVAL',
    'OCILOBLOCATOR',
    'OCINUMBER',
    'OCIRAW',
    'OCIREF',
    'OCIREFCURSOR',
    'OCIROWID',
    'OCISTRING',
    'OCITYPE',
    'OF',
    'ON',
    'ONLY',
    'OPAQUE',
    'OPEN',
    'OPERATOR',
    'OPTION',
    'OR',
    'ORACLE',
    'ORADATA',
    'ORDER',
    'OVERLAPS',
    'ORGANIZATION',
    'ORLANY',
    'ORLVARY',
    'OTHERS',
    'OUT',
    'OVERRIDING',
    'PACKAGE',
    'PARALLEL_ENABLE',
    'PARAMETER',
    'PARAMETERS',
    'PARTITION',
    'PASCAL',
    'PIPE',
    'PIPELINED',
    'PRAGMA',
    'PRECISION',
    'PRIOR',
    'PRIVATE',
    'PROCEDURE',
    'PUBLIC',
    'RAISE',
    'RANGE',
    'RAW',
    'READ',
    'RECORD',
    'REF',
    'REFERENCE',
    'REM',
    'REMAINDER',
    'RENAME',
    'RESOURCE',
    'RESULT',
    'RETURN',
    'RETURNING',
    'REVERSE',
    'REVOKE',
    'ROLLBACK',
    'ROW',
    'SAMPLE',
    'SAVE',
    'SAVEPOINT',
    'SB1',
    'SB2',
    'SB4',
    'SECOND',
    'SEGMENT',
    'SELECT',
    'SELF',
    'SEPARATE',
    'SEQUENCE',
    'SERIALIZABLE',
    'SET',
    'SHARE',
    'SHORT',
    'SIZE',
    'SIZE_T',
    'SOME',
    'SPARSE',
    'SQL',
    'SQLCODE',
    'SQLDATA',
    'SQLNAME',
    'SQLSTATE',
    'STANDARD',
    'START',
    'STATIC',
    'STDDEV',
    'STORED',
    'STRING',
    'STRUCT',
    'STYLE',
    'SUBMULTISET',
    'SUBPARTITION',
    'SUBSTITUTABLE',
    'SUBTYPE',
    'SUM',
    'SYNONYM',
    'TABAUTH',
    'TABLE',
    'TDO',
    'THE',
    'THEN',
    'TIME',
    'TIMESTAMP',
    'TIMEZONE_ABBR',
    'TIMEZONE_HOUR',
    'TIMEZONE_MINUTE',
    'TIMEZONE_REGION',
    'TO',
    'TRAILING',
    'TRANSAC',
    'TRANSACTIONAL',
    'TRUSTED',
    'TYPE',
    'UB1',
    'UB2',
    'UB4',
    'UNDER',
    'UNION',
    'UNIQUE',
    'UNSIGNED',
    'UNTRUSTED',
    'UPDATE',
    'USE',
    'USING',
    'VALIST',
    'VALUE',
    'VALUES',
    'VARIABLE',
    'VARIANCE',
    'VARRAY',
    'VARYING',
    'VIEW',
    'VIEWS',
    'VOID',
    'WHEN',
    'WHERE',
    'WHILE',
    'WITH',
    'WORK',
    'WRAPPED',
    'WRITE',
    'YEAR',
    'ZONE',
  ],
});
